import {useFocusEffect} from '@react-navigation/native';
import {useCallback, useRef} from 'react';
import {create} from 'zustand';

export const useMeStore = create<{
  loading: boolean;
  setLoading: (loading: boolean) => void;
}>(set => ({
  loading: false,
  setLoading: (loading: boolean) => {
    set({loading});
  },
}));

export function useMe() {
  const meHeaderRef = useRef<{refresh: (isClick?: boolean) => void}>();
  const {loading} = useMeStore();
  const first = useRef(true);
  const refresh = useCallback((isFirst?: boolean) => {
    meHeaderRef.current?.refresh(isFirst);
  }, []);

  useFocusEffect(
    useCallback(() => {
      setTimeout(() => {
        refresh(first.current);
        first.current = false;
      });
    }, [refresh]),
  );

  return {meHeaderRef, refresh, loading};
}
